import BannerSwiper from '@/components/main/banner/bannerSwiper'
import { MainBoard } from '@/pages/main/_components/board/mainBoard'
import { MainGolfSearch } from '@/pages/main/_components/golfSearch/mainGolfSearch'
import { RegionGraph } from '@/pages/main/_components/graph/regionGraph'
import { MainGraph } from '@/pages/main/_components/graph/mainGraph'
import React from 'react'
import styled from 'styled-components'
import { NoticePopup } from '../notice/_components/noticePopup'
import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'
import MainBanner from '@/components/main/banner/mainBanner'
import { MainYoutube } from './_components/youtube/mainYoutube'
import { MainBlog } from './_components/blog/mainBlog'
import { MainSurvey } from './_components/survey/mainSurvey'
import { MainFeedback } from './_components/feedback/mainFeedback'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'
import MainMobile from './mainMobile'

const Main: React.FC = () => {
  const { regionAvgPrice } = useSelector(
    (state: RootState) => state.golfSearch.graphData,
  )

  const { isMobile, isTablet, isDesktop } = useResponsive()

  return (
    <>
      <SEO
        title="꿀프"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr"
      />
      {isMobile ? (
        <MainMobile />
      ) : (
        <MainWrapper>
          <MainContent>
            <MainGraph />
            <div style={{ marginBottom: '10px' }} />
            <MainGolfSearch />
            <div style={{ marginBottom: '10px' }} />
            <ContentWrapper>
              <LeftContainer>
                <MainYoutube />
              </LeftContainer>
              <RightContainer>
                <MainFeedback />
              </RightContainer>
            </ContentWrapper>
            <div style={{ marginBottom: '10px' }} />
            <ContentWrapper>
              <LeftContainer>
                <MainBlog />
              </LeftContainer>
              <RightContainer>
                <MainSurvey />
                <MainBoard />
              </RightContainer>
            </ContentWrapper>
          </MainContent>
          <NoticePopup />
        </MainWrapper>
      )}
    </>
  )
}

const MainWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: relative;

  @media (max-width: 768px) {
    /* 모바일에서는 전체 너비 사용, 패딩 최소화 */
    padding: 0;
    margin: 0;
  }
`

const SideBannerWrapper = styled.div<{ position: 'left' | 'right' }>`
  position: fixed;
  top: 0;
  ${(props) => props.position}: 0;
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  @media (max-width: 768px) {
    display: none;
  }
`

const MainContent = styled.div`
  width: 100%;
  max-width: 1200px; /* 데스크톱 최대 너비 제한 */
  margin: 0 auto;
  padding: 30px 20px; /* 데스크톱 좌우 패딩 */
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    /* 모바일에서는 패딩을 최소화하고 전체 너비 활용 */
    padding: 20px 10px;
    max-width: 100%;
    width: 100%;
    margin: 0;
  }

  @media (max-width: 480px) {
    /* 더 작은 화면에서는 패딩을 더욱 최소화 */
    padding: 15px 8px;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px; /* 모바일에서는 세로 간격을 조금 늘림 */
  }
`

const LeftContainer = styled.div`
  flex: 1;
  min-width: 0; /* flex item의 축소를 허용 */
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {
    /* 데스크톱에서만 50% 제한 */
    min-width: calc(50% - 5px);
  }

  @media (max-width: 768px) {
    /* 모바일에서는 전체 너비 사용 */
    width: 100%;
    min-width: 100%;
  }
`

const RightContainer = styled.div`
  flex: 1;
  min-width: 0; /* flex item의 축소를 허용 */
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: 769px) {
    /* 데스크톱에서만 50% 제한 */
    min-width: calc(50% - 5px);
  }

  @media (max-width: 768px) {
    /* 모바일에서는 전체 너비 사용 */
    width: 100%;
    min-width: 100%;
    gap: 15px;
  }
`

export default Main
